import React, { useEffect } from 'react'
import ReviewForm from './ReviewForm';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../global/LoadingSpinner';
import { useState } from 'react';
import LanguagesSelector from './LanguagesSelector';
import ImageWithFallback from '../global/ImageWithFallback';
import ThankYouModal from './ThankYouModal';
import { displayName } from '../../helpers/templateHelpers';

import { useGetVendor } from '../../hooks/public/Vendors';
import { useGetProduct } from '../../hooks/public/Product';
import { useGetActiveMotivator } from '../../hooks/public/Motivators';
import { useGetProfile } from '../../hooks/profiles/Profiles';

export default function ReviewFromProduct({ id = null, code = null }) {

  const { t, i18n } = useTranslation();
  const history = localStorage.getItem('review');
  let historyData = []
  if (history) historyData = JSON.parse(history);

  const { data, isLoading, isError } = useGetVendor();
  const { data: product, isLoading: productIsLoading, isError: productIsError } = useGetProduct({ id: id });
  const { data: profile, isLoading: profileIsLoading, isError: profileIsError } = useGetProfile();
  const { data: prizeGame, isLoading: prizeGameIsLoading, isError: prizeGameIsError } = useGetActiveMotivator();
  const [lng, setLang] = useState(i18n.language.toUpperCase());
  const [finish, setFinish] = useState(false);

  useEffect(() => {
    setLang(i18n.language.toUpperCase());
  }, [i18n.language]);

  if (isLoading || productIsLoading || prizeGameIsLoading || profileIsLoading) return <LoadingSpinner />
  if (isError || productIsError || prizeGameIsError || profileIsError) return 'An error has occurred: ' + isError.message;


  const isAlreadyReviewed = historyData.find((item) => item.id === product.productData.id);

  const onFinished = () => {
    setFinish(true);

    if (!isAlreadyReviewed) {
      // Add new entry if not already reviewed
      historyData.push({ id: product.productData.id, date: new Date().toISOString() });
    } else {
      // Update the date for the existing review
      historyData = historyData.map((item) =>
        item.id === product.productData.id
          ? { ...item, date: new Date().toISOString() } // Update date for matching id
          : item // Keep other entries unchanged
      );
    } 

    localStorage.setItem('review', JSON.stringify(historyData));
  }


  if(isAlreadyReviewed && !data.invoice_invite_settings?.restrict_to_device) {
    const lastReviewDate = new Date(isAlreadyReviewed.date);
    lastReviewDate.setSeconds(lastReviewDate.getSeconds() + data.review_form_auto_refresh_seconds);

    if(lastReviewDate > new Date()) {
      return (<><ThankYouModal www={profile?.[0].www}  /> </>)
    }
  }


  let number = 0;

  if (finish) return (<><ThankYouModal www={profile?.[0].www} /> </>)

  return (
    <div className="reviewInvite">

      <div className="wrapper">
        <div className="container container-relative">
          <LanguagesSelector lang={data.languages} />
          <div className="row">
            <div className="col-xs-12 col-sm-10 col-md-8 mx-auto">
              <section className="box invitation">
                <div className="content">
                  <div className="vendor">
                    <div className="row">
                      <div className="col-sm-12 text-center">

                        <ImageWithFallback src={data.logo_url} alt={data.logo_url} />
                        {/** <img src="createImgixUrl(config.imgixHost, vendor.logoUrl, 252)" /> **/}
                        {!data.logo_url &&
                          <h2>{data.name}</h2>
                        }
                      </div>
                    </div>
                  </div>
                  {data &&
                    <ReviewForm
                      id={product.productData.sourceId}
                      number={number++}
                      title={product.groupData.texts.reviewTitle}
                      subTitle={product.productData.name}
                      image={product?.productData.img_url}
                      displayElementDetails={(product.groupData.display_element_details) ? product.groupData.display_element_details : false}
                      customerName={null}
                      customerSurname={null}
                      anonymous={data.anonymous_reviewing}
                      questionsData={product.questionsData}
                      prizeGame={prizeGame}
                      prizeGameVisible={product.groupData.show_prize_game}
                      termsVisible={data.terms_of_use_visible}
                      data={{
                        type: "PRODUCT",
                        sourceId: product.productData.sourceId,
                        company_id: null,
                        user_id: null,
                        text: null,
                        score: null,
                        answers: {},
                        language: lng,
                        group_id: product.groupData.id,
                        invitation_reference_number: code,
                        product_id: product.productData.id,
                        source_id: product.productData.sourceId,
                        vendor_id: data.id,
                        customerName: null,
                        customerSurname: null,
                        prize_game: prizeGame,
                        prize_game_id: prizeGame?.id
                      }}
                      onSubmit={() => onFinished()} />
                  }
                  <p className="authorName">{t("review.revEn")}<strong> artur.com</strong></p>

                  {!data.anonymous_reviewing && data.customer_name && data.customer_surname &&
                    <p className="copyArtur">{t("review.disN")}: {displayName(data.customer_name, data.customer_surname)}</p>
                  }
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
